module.exports = __webpack_public_path__ + "img/icon_star@2x.51defdb2.png";